import { render, staticRenderFns } from "./compWaitingRebateRecord.vue?vue&type=template&id=afe42432&"
import script from "./compWaitingRebateRecord.vue?vue&type=script&lang=js&"
export * from "./compWaitingRebateRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports